// Ronsoco footer (sections/ronsoco-footer.liquid): tap-to-open columns on phones, the country / region list,
// Cookie Preferences, and the sign-up error when another form sent it.
(() => {
  if (window.ronsocoFooter) return;

  const phone = window.matchMedia('(max-width: 749px)');

  // ---------- Columns ----------
  const toggleColumn = (button) => {
    const column = button.closest('[data-rft-col]');
    const open = !column.classList.contains('is-open');
    column.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open);
  };

  // ---------- Country / Region ----------
  const regionParts = (wrap) => ({
    button: wrap.querySelector('[data-rft-region-toggle]'),
    panel: wrap.querySelector('[data-rft-region-panel]'),
    search: wrap.querySelector('[data-rft-region-search]'),
    empty: wrap.querySelector('[data-rft-region-empty]'),
  });

  const filterRegions = (wrap) => {
    const { panel, search, empty } = regionParts(wrap);
    const query = search.value.trim().toLowerCase();
    let shown = 0;
    panel.querySelectorAll('li[data-search]').forEach((item) => {
      const match = !query || item.dataset.search.includes(query);
      item.hidden = !match;
      if (match) shown += 1;
    });
    empty.hidden = shown > 0;
  };

  const closeRegion = (wrap, returnFocus) => {
    const { button, panel, search } = regionParts(wrap);
    if (panel.hidden) return;
    panel.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    search.value = '';
    filterRegions(wrap);
    if (returnFocus) button.focus();
  };

  const openRegion = (wrap) => {
    const { button, panel, search } = regionParts(wrap);
    panel.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    const current = panel.querySelector('[aria-current="true"]');
    if (current) current.scrollIntoView({ block: 'nearest' });
    // A phone keyboard would cover the list, so only jump into the search box with a mouse
    if (!phone.matches) search.focus();
  };

  // ---------- Cookie Preferences ----------
  // For visitors whose region gets Shopify's cookie banner: it's due now (shouldShowBanner), or they have
  // already answered it (shouldShowBanner turns false then, so their saved choices count too)
  const cookieChoicesApply = (privacy) => {
    if (privacy.shouldShowBanner()) return true;
    if (typeof privacy.currentVisitorConsent !== 'function') return false;
    const consent = privacy.currentVisitorConsent() || {};
    return ['analytics', 'marketing', 'preferences'].some((key) => consent[key] === 'yes' || consent[key] === 'no');
  };

  // Shopify's cookie banner script arrives after the page, so look for it for a few seconds
  const showCookieLinks = (tries = 0) => {
    const links = document.querySelectorAll('[data-rft-cookie]');
    if (!links.length) return;
    const banner = window.privacyBanner;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (banner && typeof banner.showPreferences === 'function' && privacy && typeof privacy.shouldShowBanner === 'function') {
      const show = cookieChoicesApply(privacy);
      links.forEach((link) => {
        link.hidden = !show;
      });
      return;
    }
    if (tries < 20) setTimeout(() => showCookieLinks(tries + 1), 500);
  };

  // ---------- Sign-up ----------
  // Every Shopify sign-up form on the page shows the result, so drop an error that came from another form
  const tidySignup = () => {
    const form = document.getElementById('RonsocoFooterForm');
    if (!form || window.location.hash === '#RonsocoFooterForm') return;
    const error = form.querySelector('[data-rft-error]');
    if (!error) return;
    error.hidden = true;
    const input = form.querySelector('input[type="email"]');
    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('autofocus');
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-rft-toggle]');
    if (toggle) {
      toggleColumn(toggle);
      return;
    }

    const cookie = event.target.closest('[data-rft-cookie-button]');
    if (cookie) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      return;
    }

    const regionButton = event.target.closest('[data-rft-region-toggle]');
    document.querySelectorAll('[data-rft-region]').forEach((wrap) => {
      if (regionButton && wrap.contains(regionButton)) {
        if (regionParts(wrap).panel.hidden) {
          openRegion(wrap);
        } else {
          closeRegion(wrap, false);
        }
      } else if (!wrap.contains(event.target)) {
        closeRegion(wrap, false);
      }
    });
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-rft-region-search]')) filterRegions(event.target.closest('[data-rft-region]'));
  });

  document.addEventListener('keydown', (event) => {
    const wrap = event.target.closest && event.target.closest('[data-rft-region]');
    if (!wrap) return;
    if (event.key === 'Escape') {
      closeRegion(wrap, true);
      return;
    }
    // Enter in the search box picks the first country still listed
    if (event.key === 'Enter' && event.target.matches('[data-rft-region-search]')) {
      event.preventDefault();
      const first = [...wrap.querySelectorAll('li[data-search]')].find((item) => !item.hidden);
      if (first) first.querySelector('button').click();
    }
  });

  // Leaving the picker with Tab closes it
  document.addEventListener('focusout', (event) => {
    const wrap = event.target.closest && event.target.closest('[data-rft-region]');
    if (wrap && event.relatedTarget && !wrap.contains(event.relatedTarget)) closeRegion(wrap, false);
  });

  const init = () => {
    tidySignup();
    showCookieLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.rft')) showCookieLinks();
  });

  window.ronsocoFooter = { openRegion, closeRegion, showCookieLinks };
})();
